import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useShop } from '../context/ShopContext';
import { Home, Grid, Heart, ShoppingCart, Scale, User } from 'lucide-react';

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { 
    cartCount, 
    wishlist, 
    setActiveCategory,
    setIsWastageModalOpen,
    isCustomerLoggedIn,
    openCustomerAuthModal
  } = useShop();

  const handleHomeClick = () => {
    navigate('/');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleCategoriesClick = () => {
    setActiveCategory('all');
    navigate('/category/all');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const isHome = location.pathname === '/';
  const isCategories = location.pathname.startsWith('/category');
  const isWishlist = location.pathname === '/wishlist';
  const isCart = location.pathname === '/cart';

  // On Product Detail Page, let the dedicated Flipkart Sticky Buy Bar handle mobile action buttons
  if (location.pathname.startsWith('/product/')) {
    return null;
  }

  return (
    <div 
      className="mobile-bottom-nav"
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        height: '56px',
        backgroundColor: '#ffffff',
        borderTop: '1px solid #e0e0e0',
        zIndex: 950,
        display: 'none',
        alignItems: 'center',
        justifyContent: 'space-around',
        padding: '0 4px',
        boxShadow: '0 -2px 8px rgba(0, 0, 0, 0.08)'
      }}
    >
      {/* Home */}
      <button
        onClick={handleHomeClick}
        style={{
          background: 'none',
          border: 'none',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '2px',
          color: isHome ? '#2874f0' : '#717478',
          cursor: 'pointer',
          padding: '4px'
        }}
      >
        <Home size={20} color={isHome ? '#2874f0' : '#717478'} />
        <span style={{ fontSize: '0.68rem', fontWeight: isHome ? 700 : 500 }}>Home</span>
      </button>

      {/* Categories */}
      <button
        onClick={handleCategoriesClick}
        style={{
          background: 'none',
          border: 'none',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '2px',
          color: isCategories ? '#2874f0' : '#717478',
          cursor: 'pointer',
          padding: '4px'
        }}
      >
        <Grid size={20} color={isCategories ? '#2874f0' : '#717478'} />
        <span style={{ fontSize: '0.68rem', fontWeight: isCategories ? 700 : 500 }}>Categories</span>
      </button>

      {/* 0% Wastage Calculator */}
      <button
        onClick={() => {
          navigate('/wastage-calculator');
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }}
        style={{
          background: 'none',
          border: 'none',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '2px',
          color: location.pathname === '/wastage-calculator' ? '#2874f0' : '#388e3c',
          cursor: 'pointer',
          padding: '4px'
        }}
      >
        <Scale size={20} color={location.pathname === '/wastage-calculator' ? '#2874f0' : '#388e3c'} />
        <span style={{ fontSize: '0.68rem', fontWeight: location.pathname === '/wastage-calculator' ? 700 : 600 }}>0% Wastage</span>
      </button>

      {/* Account / Dashboard */}
      <button
        onClick={() => {
          if (isCustomerLoggedIn) {
            navigate('/account');
          } else {
            openCustomerAuthModal('login');
          }
        }}
        style={{
          background: 'none',
          border: 'none',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '2px',
          color: (location.pathname === '/account' || location.pathname === '/customer-dashboard') ? '#2874f0' : '#717478',
          cursor: 'pointer',
          padding: '4px'
        }}
      >
        <User size={20} color={(location.pathname === '/account' || location.pathname === '/customer-dashboard') ? '#2874f0' : '#717478'} />
        <span style={{ fontSize: '0.68rem', fontWeight: (location.pathname === '/account' || location.pathname === '/customer-dashboard') ? 700 : 500 }}>
          {isCustomerLoggedIn ? 'Account' : 'Login'}
        </span>
      </button>

      {/* Cart */}
      <button
        onClick={() => navigate('/cart')}
        style={{
          background: 'none',
          border: 'none',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '2px',
          color: isCart ? '#2874f0' : '#717478',
          cursor: 'pointer',
          padding: '4px',
          position: 'relative'
        }}
      >
        <ShoppingCart size={20} color={isCart ? '#2874f0' : '#717478'} />
        <span style={{ fontSize: '0.68rem', fontWeight: isCart ? 700 : 500 }}>Cart</span>
        {cartCount > 0 && (
          <span style={{
            position: 'absolute',
            top: '0',
            right: '8px',
            backgroundColor: '#ffe500',
            color: '#2874f0',
            fontSize: '0.58rem',
            fontWeight: 800,
            width: '15px',
            height: '15px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: '1px solid #2874f0'
          }}>
            {cartCount}
          </span>
        )}
      </button>

      <style>{`
        @media (max-width: 768px) {
          .mobile-bottom-nav {
            display: flex !important;
          }
        }
      `}</style>
    </div>
  );
}
